import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"section-row\"><h3 class=\"section-title\">Project Background</h3><h3 class=\"section-title\">My role in this project</h3></div><div class=\"section-row\"><h3 class=\"section-title\">Chalanges</h3></div><div class=\"section-row\"><h3 class=\"section-title\">Biggest Lessons Learned</h3></div><div class=\"section-row\"><h3 class=\"section-title\">Summary</h3></div>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoverImage = _resolveComponent("CoverImage")
  const _component_Testimonial = _resolveComponent("Testimonial")
  const _component_OtherProjectCaseStudies = _resolveComponent("OtherProjectCaseStudies")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_CoverImage, {
      url: `/images/projects/${_ctx.project.thumbnail}`
    }, null, 8, ["url"]),
    _hoisted_1,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testimonials, (t) => {
      return (_openBlock(), _createBlock(_component_Testimonial, {
        key: t.author,
        author: t.author,
        body: t.body,
        title: t.title,
        "picture-url": t.pictureUrl,
        type: t.type,
        url: t.url
      }, null, 8, ["author", "body", "title", "picture-url", "type", "url"]))
    }), 128)),
    _createVNode(_component_OtherProjectCaseStudies, { projects: _ctx.projects }, null, 8, ["projects"])
  ], 64))
}